export enum QueryKeys {
  AUTHENTICATION = 'authentication',
  MENU = 'menu',
  SCHOOLS = 'escolas',
  YEARS = 'years',
  TURMAS = 'turmas',
  CLASS_RANKING = 'class-ranking',
  STUDENTS_RANKING = 'students-ranking',
  CATEGORIES = 'categories',
  CATEGORY_MODELS = 'category-models',
  ENGAGEMENT_GAUGE_CHART = 'engagement-gauge-chart',
  THEMES = 'themes',
  THEME_FILTER_OPTIONS = 'theme-filter-options',
  THEME_SEARCH_SUGGESTIONS = 'theme-search-suggestions',
  SCHOOL_YEARS = 'school-years',
  THEME_COLLECTIONS = 'theme-collections',
  MY_THEMES = 'my-themes',
  SAVED_THEMES = 'saved-themes',
  USER_NETWORKS = 'user-networks',
  DASHBOARD_RESULTS = 'dashboard-results',
  CREDITS = 'credits',
  LATEST_TASKS = 'latest-tasks',
  BANNER = 'banner',
  REWRITE_AND_PROGRESS = 'rewrite-and-progress',
  PERFORMANCE_EVOLUTION = 'performance-evolution',
  PERFORMANCE_BY_COMPETENCE = 'performance-by-competence',
  FEEDBACK_ANALYSIS = 'feedback-analysis',
  INICIA_PAGAMENTO = 'inicia-pagamento',
  PIX_QR_CODE = 'pix-qr-code',
  DASHBOARD_SERIES = 'dashboard-series',
  ANNOTATIONS_ANALYSIS = 'annotations-analysis',
  TASK_OVERVIEW = 'task-overview',
  TAGS_ANALYSIS = 'tags-analysis',
  DASHBOARD_RESULTS_BY_TASK = 'dashboard-results-by-task',
  PERFORMANCE_EVOLUTION_BY_TASK = 'performance-evolution-by-task',
  PERFORMANCE_BY_COMPETENCE_BY_TASK = 'performance-by-competence-by-task',
  TAGS_ANALYSIS_BY_TASK = 'tags-analysis-by-task',
  REWRITE_AND_PROGRESS_BY_TASK = 'rewrite-and-progress-by-task',
  STUDENTS = 'students',
  STUDENT_INFO = 'student-info',
  TASK_INFO_SCHOOLS = 'task-info-schools',
  DASHBOARD_RESULTS_LOGADO = 'dashboard-results-logado',
  PERFORMANCE_BY_COMPETENCE_LOGADO = 'performance-by-competence-logado',
  PERFORMANCE_EVOLUTION_LOGADO = 'performance-evolution-logado',
  TAGS_ANALYSIS_LOGADO = 'tags-analysis-logado',
  REWRITE_AND_PROGRESS_LOGADO = 'rewrite-and-progress-logado',
  CATEGORY_MODELS_LOGADO = 'category-models-logado',
  BENCHMARKING_HEADER = 'benchmarking-header',
  BENCHMARKING_INFO = 'benchmarking-info',
  BENCHMARKING_RANKING_REGIONAL = 'benchmarking-ranking-regional',
  BENCHMARKING_GOAL_EVOLUTION = 'benchmarking-goal-evolution',
  BENCHMARKING_ESSAY_EVOLUTION = 'benchmarking-essay-evolution',
  BENCHMARKING_PERFORMANCE_COMPARISON = 'benchmarking-performance-comparison',
  BENCHMARKING_CLASS_PERFORMANCE = 'benchmarking-class-performance',
  BENCHMARKING_ANALISE_APONTAMENTOS = 'benchmarking-analise-apontamentos',
  BENCHMARKING_DESEMPENHO_POR_COMPETENCIA = 'benchmarking-desempenho-por-competencia',
  BENCHMARKING_STRATEGIC_INSIGHTS = 'benchmarking-strategic-insights',
  CREDIT_STATEMENT = 'credit-extrato',
  LEARNING_PATH = 'learning-path',
  LEARNING_PATHS = 'learning-paths',
  STUDENT_LEARNING_PATHS = 'student-learning-paths',
  LEARNING_PATH_OVERVIEW = 'learning-path-overview',
  LEARNING_PATH_STUDENTS = 'learning-path-students',
  LEARNING_PATH_CLASSES = 'learning-path-classes',
  LEARNING_PATH_AVAILABILITY = 'learning-path-availability',
}
